import { render, staticRenderFns } from "./country-company-encode.vue?vue&type=template&id=4c062c0f&scoped=true&"
import script from "./country-company-encode.vue?vue&type=script&lang=js&"
export * from "./country-company-encode.vue?vue&type=script&lang=js&"
import style0 from "./country-company-encode.vue?vue&type=style&index=0&id=4c062c0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c062c0f",
  null
  
)

export default component.exports